// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"473b08f6","860":"1240467a"}[chunkId] + ".chunk.css";
};